import { GetPartnerUserForms } from 'js/library/utils/API/getPartnerUserById';
import { getUsersByPartner } from 'js/library/utils/API/apiGetUsersByPartner';
import { getClientsEstablishment } from 'js/library/utils/API/apiGetClients';
import { ValidateUserPartner } from 'js/library/utils/API/apiValidateUserPartnerClub';
import { GetUserPartner } from 'js/library/utils/API/apiGetUserPartner';

// para saber qual é a chave do clube
const getClubToken = async (partnerId, setClubKey) => {
  try {
    const partner = await GetPartnerUserForms(partnerId);

    // filtra os campos em que indexKey é true
    const fieldsWithIndexKeyTrue = partner.formFields.filter((field) => field.indexKey === true);

    // verifica se há algum resultado no array antes de acessar o campo fieldType
    if (fieldsWithIndexKeyTrue.length > 0) {
      setClubKey(fieldsWithIndexKeyTrue[0].fieldType);
    }
  } catch (error) {
    console.error('Ocorreu um erro na GetPartnerUserForms:', error);
  }
};

// para saber se o usuário pertence ao clube
const getUsersPartner = async (partnerId, clubKey, setDataUsers) => {
  try {
    const response = await getUsersByPartner(partnerId);

    if (response && Array.isArray(response)) {
      // mapeamento de clubKey para type
      const keyMap = {
        cpf: 'cpf',
        cnpj: 'cnpj',
        cellPhone: 'cellPhone',
        email: 'email',
      };

      // verifica se o clubKey tem um tipo correspondente
      const typeToFind = keyMap[clubKey];

      // percorre o array e filtra apenas os usuários que possuem o dado relevante
      const users = response
        .map((user) => {
          // busca o valor correspondente ao clubKey
          const getValueFromType = () => {
            if (!typeToFind) return null;

            // documentList
            if (user.documentList) {
              const document = user.documentList.find((doc) => doc.type === typeToFind);
              if (document) return document.value;
            }

            // contactList
            if (user.contactList) {
              const contact = user.contactList.find((cont) => cont.type === typeToFind);
              if (contact) return contact.value;
            }

            return null;
          };

          const key = getValueFromType();
          if (!key) return null; // se não houver um valor válido, ignora esse usuário

          return {
            key,
            name: user.aliasName || '--',
            uId: user.uid || 'N/A',
          };
        })
        .filter(Boolean); // remove valores nulos da lista

      setDataUsers(users);
    }
  } catch (error) {
    console.error('Ocorreu um erro na getUsersByPartner:', error);
  }
};

// para saber se o usuário pertence ao clube (clubmapfre)
const getUserClubMapfre = async (token, partnerId, setDataUsers, setLoadingValidateUserMapfre) => {
  try {
    const response = await ValidateUserPartner(token, partnerId);
    const data = await GetUserPartner(partnerId, response.uId);

    const getValueFromType = () => {
      if (data.response.documentList) {
        const document = data.response.documentList.find((doc) => doc.type === 'cpf');
        if (document) return document.value;
      }
    };

    const key = getValueFromType();

    if (data?.response) {
      setDataUsers({
        key,
        name: data.response.aliasName,
        uId: data.response.uId,
      });
    }
    setLoadingValidateUserMapfre(false);
  } catch (error) {
    console.error('Ocorreu um erro na validateUserMapfre:', error);
  }
};

// para saber se o usuário pertence ao estabelecimento
const getClients = async (establishmentId, setDataUsers) => {
  try {
    const response = await getClientsEstablishment(establishmentId);

    if (response?.registered?.length) {
      const clientsNotNull = response.registered.filter((e) => e !== null);

      if (clientsNotNull.length > 0) {
        const formattedClients = clientsNotNull
          .map((client) => {
            const phoneContact = client.contactList?.find((c) => c.type === 'cellPhone');

            return {
              key: phoneContact?.value || '', // define o telefone como key
              name: client.name,
              uId: client.uId,
            };
          })
          .filter((client) => client.key); // filtra os que não têm telefone válido

        setDataUsers((prevData) => {
          // garante que prevData seja um array
          const safePrevData = Array.isArray(prevData) ? prevData : [];

          // evita adicionar usuários duplicados com base no telefone (key)
          const existingKeys = new Set(safePrevData.map((user) => user.key));
          const newUsers = formattedClients.filter((user) => !existingKeys.has(user.key));

          return [...safePrevData, ...newUsers];
        });
      }
    }
  } catch (error) {
    console.error('Erro ao buscar clientes do estabelecimento:', error);
  }
};

export default { getClubToken, getUsersPartner, getUserClubMapfre, getClients };
